export type PathParts = {
    hash?: string | null;
    pathname: string;
    query?: string;
};

/**
 *  Takes relative pathname and splits into query, hash, and pathname with no hash/query
 */
export const getPathParts = (relativePath: string = ""): PathParts => {
    const [basepath, hash] = relativePath.split("#");
    const [pathname, query] = basepath.split("?");
    return { pathname, hash, query };
};

export type SetQueryParamProps = {
    key: string;
    query?: string;
    value?: any;
};

/**
 *  Takes existing query string and sets or removes the param indicated
 */
export const setQueryParam = ({ key, query, value }: SetQueryParamProps): string => {
    const params = new URLSearchParams(query || "");

    if (value === undefined) {
        params.delete(key);
    } else {
        params.set(key, value);
    }

    return params.toString();
};
